<template>
  <div
    class="teaser"
    :class="{ 'teaser--image': teaser.thumbnail }"
    :style="teaserStyle"
  >
  <div :class="teaser.photoLinkText === '' ? 'mb-auto' : 'mt-auto'">
    <small class="teaser__pre-header" v-if="teaser.photoTagLine">{{
      teaser.photoTagLine
    }}</small>
    <h3 class="teaser__header" v-if="teaser.photoTitle">
      {{ teaser.photoTitle }}
    </h3>
  </div>
    <div class="teaser__txt">
      <div class="mb-4" v-html="teaser.photoText"></div>
      <a
        :href="teaser.photoLink"
        :class="teaser.thumbnail ? 'btn-outline-light' : 'btn-outline-primary'"
        class="teaser__btn btn" v-if="teaser.photoLink && teaser.photoLinkText"
        @click="setHistoryState(teaser.photoLink, $event)"
        >{{ teaser.photoLinkText }}</a
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "TeaserTile",
  props: ["teaser"],
  data() {
    return {};
  },
  computed: {
    teaserStyle() {
      return this.teaser.thumbnail
        ? `background-image: url(${this.teaser.thumbnail})`
        : this.teaser.photoBackgroundColor
        ? `background-color: ${this.teaser.photoBackgroundColor}`
        : "";
    }
  },
  methods: {
    setHistoryState(url, event) {
      window.history.replaceState(
        { scrollY: document.documentElement.scrollTop },
        document.title,
        window.location.pathname + window.location.search
      );
    }
  }
});
</script>
